<script setup lang="ts">
import Icon from '@components/Icon.vue';
import IconGooglemapsMarker from '@icons/ph_googlemaps_marker.svg';
import Typography from '@components/Typography.vue';
import { useCustomMarkerStore } from '@organisms/offer/selection-items/stores/useCustomMarkerStore';
import { storeToRefs } from 'pinia';
import { trans } from '@elements/translation';
import Button from '@components/Button.vue';
import { computed } from 'vue';

const customMarkerStore = useCustomMarkerStore();
const { open: openSlider } = customMarkerStore;
const { savedDealUdurMarker } = storeToRefs(customMarkerStore);

const text = computed<string>(() => {
  const address = savedDealUdurMarker.value;
  if (address) {
    return address.name || address.label;
  }

  return trans('selection_item.custom_marker.add');
});
</script>

<template>
  <Button class="custom-marker" @click="openSlider">
    <div class="custom-marker__icon">
      <Icon :svg="IconGooglemapsMarker" :width="24" :height="24" />
    </div>
    <div class="custom-marker__text">
      <Typography variant="caption" as="span">
        {{ text }}
      </Typography>
    </div>
  </Button>
</template>

<style scoped lang="scss">
@use '@styles/mixins' as *;

.custom-marker {
  &__icon {
    display: flex;
  }

  &__text {
    @include fontCaption();
    overflow: hidden;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
